import * as actionTypes from "./actionTypes";

export const firstBotCreateAction = (data) => {
  return {
    type: actionTypes.firstBotCreateActionType,
    payload: data,
  };
};
